import { __awaiter, __generator, __spreadArray } from "tslib";
import axiosInstance from "../axiosInstance";
import endpoints from "../endpoints";
export var fetchUserMetaData = function () { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axiosInstance.get("".concat(endpoints.api.getUserMetadata), {})];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.data];
        }
    });
}); };
export var fetchUserProfile = function (targetUsername_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([targetUsername_1], args_1, true), void 0, function (targetUsername, view) {
        var res;
        if (view === void 0) { view = "private"; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axiosInstance.get("".concat(endpoints.api.getUserProfile, "/").concat(targetUsername), { params: { view: view } })];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res.data];
            }
        });
    });
};
export var updateUserProfile = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axiosInstance.put(endpoints.api.updateUserProfile, payload)];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.data];
        }
    });
}); };
